import React, { FC } from 'react';
import { bookingLink } from '@helpers/endpoints';
import st from './Service.module.css';

type ServiceProps = {
  service: ServiceTypeProps;
  office?: {
    bookableServicesIds: [number];
    id: number;
  };
  onCatalogOpen: () => void;
};

const Service: FC<ServiceProps> = ({ service, office, onCatalogOpen }) => {
  const { id: officeId, bookableServicesIds = [] } = office || {};
  const { id: serviceId, name: serviceName } = service;
  // @ts-ignore
  const bookable = bookableServicesIds.includes(serviceId);
  const serviceLink = `${bookingLink}?service=${serviceId}&office=${officeId}`;

  return (
    <div className={st.service} data-testid="choosenService">
      <div className={st.main}>
        {office && (
          <small className={st.type}>
            {bookable ? 'по записи' : 'в порядке очереди'}
          </small>
        )}
        <div className={st.name}>{serviceName}</div>
        {office && bookable && (
          <a className={st.bookButton} href={serviceLink}>
            Выбрать время
          </a>
        )}
        {office && !bookable && (
          <p className={st.note}>
            Услуга доступна без&nbsp;записи и&nbsp;оказывается в&nbsp;порядке
            электронной&nbsp;очереди
          </p>
        )}
      </div>
      <button
        data-testid="choosenServiceOther"
        className={st.serviceButton}
        type="button"
        onClick={onCatalogOpen}
      >
        Выбрать другую услугу
      </button>
    </div>
  );
};

export default Service;
